import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import VerificationCodeInput from "../common/VerificationCodeInput";
import { track } from "../../api/heap";
import * as actions from "../../state/actions/onboarding";
import Logo from "../../assets/Logo";
import CheckmarkIcon from "../../assets/CheckmarkIcon";

const contactUrl = `${process.env.REACT_APP_DOMAIN}/contact`;

class VerifyCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      error: null,
      checking: false
    };
  }

  static propTypes = {
    stepNumber: PropTypes.number.isRequired,
    phoneVerificationError: PropTypes.string.isRequired
  };

  componentDidMount() {
    if (
      !this.props.noPropsCheck &&
      (!this.props.user || !this.props.user.phoneNumber.length)
    ) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        this.props.startOver();
      }, 1000);
    }

    window.onpopstate = event => {
      console.log("User pressed 'back' - marking phone verif as not sent"); // TODO: This could be causing problems!
      this.props.verificationSmsSent(false);
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.phoneVerified || nextProps.phoneVerificationError) {
      this.setState({ checking: false });
    }
    if (nextProps.phoneVerified === true) {
      this.props.updateUserDatabase(this.props.user.email, {
        applicationProgress: {
          lastCompletedStep: 1,
          verifyPhone: true,
          lastUpdated: new Date()
        }
      });
      this.props.nextStep(null, true);
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  componentDidUnmount() {
    window.onpopstate = () => { };
  }

  handleNext = () => {
    if (this.state.transitioning) return;
    this.setState({ transitioning: true });
    if (this.props.noValidate) {
      this.props.nextStep(null, true);
      return;
    }

    this.verifyCode();
  };

  verifyCode = (code = this.state.code) => {
    if (this.isCodeValid(code) === false) {
      this.setState({ transitioning: false });
      return;
    }
    const { phoneNumber, email } = this.props.user;
    this.setState({ checking: true });
    this.props.verificationSmsCheck({
      phoneNumber,
      code,
      userId: email
    });
  };

  isCodeValid = (code = this.state.code) => {
    console.log("isCodeValid with code ", code);
    if (code === "" || code.length !== 5) {
      track("ONBOARDING_ERROR_PHONE_CODE_VERIFICATION_STEP", {
        message: "phone_code_invalid_format"
      });
      this.setState({
        error: "Please enter the five-digit verification code"
      });
      return false;
    } else {
      this.setState({ error: null });
      return true;
    }
  };

  useDifferentPhone = () => {
    track("ONBOARDING_PHONE_CODE_VERIFICATION_STEP_PHONE_NUMBER_CHANGE");
    this.props.verificationSmsReset();
    this.props.previousStep();
  };

  resendSms = () => {
    track("ONBOARDING_PHONE_CODE_VERIFICATION_STEP_RESEND_CODE");
    this.props.verificationSmsSend(this.props.user.phoneNumber);
    this.setState({ resent: true });
  };

  renderEditNumber = () => {
    return (
      <span
        className="text-gray-primary hover:text-black cursor-pointer"
        onClick={() => {
          console.log("edit!");
          this.props.verificationSmsSent(false);
          this.props.previousStep();
        }}
      >
        (<span>edit</span>)
      </span>
    );
  };

  render() {
    const {
      handleNext,
      verifyCode,
      useDifferentPhone,
      resendSms,
      renderEditNumber
    } = this;
    const { error, checking, resent } = this.state;
    const { phoneNumber } = this.props.user;
    const { phoneVerificationError, smsSendError } = this.props;
    const pn = phoneNumber ? phoneNumber.toString() : "";

    if (!this.props.noPropsCheck && !phoneNumber.length) {
      return (
        <div className="fixed-centered">
          <p>Well, you're not supposed to be here :/</p>
          <p>Sending you back to a safe place...</p>
        </div>
      );
    }

    return (
      <>
        {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
        <div className="outerStack-mobile sm:outerStack">
          <div className="innerStack-mobile md:innerStack">
            <h1 className="stepDescriptionText">Enter confirmation code</h1>
            <p className="w-10/12 mx-auto font-open-sans">
              Please enter the 5 digit code sent to your number{" "}
              <span className="text-primary">
                +x xxx xxx-{pn.slice(pn.length - 4, pn.length)}
              </span>{" "}
              {renderEditNumber()}
            </p>
            {/* TODO: Fix autofocus. React and autofocus don't always play nicely together :/ */}
            <VerificationCodeInput
              onChange={newValue => {
                if (newValue.length === 5) {
                  console.log("verifying code");
                  verifyCode(newValue);
                }
                this.setState({ code: newValue });
              }}
              autofocus
              disabled={checking}
              style={{ marginTop: 25}}
              fontSize={4}
            />
            <div>
              {error && (
                <div className="text-red-400 font-open-sans text-sm px-3 mt-5">
                  {" "}
                  <i class="far fa-solid fa-triangle-exclamation mr-1"></i>
                  {error}
                </div>
              )}
              {phoneVerificationError && (
                <div className="text-red-400 font-open-sans text-sm px-3 mt-5">
                  {" "}
                  <i class="far fa-solid fa-triangle-exclamation mr-1"></i>
                  {phoneVerificationError}
                </div>
              )}
            </div>
            <button className="continueButton cursor-pointer" disabled={checking || this.state.transitioning} style={{ backgroundColor: checking ? "gray" : "#26E3BA" }}
              onClick={handleNext}> {checking ?
                <i className="fas fa-solid fa-circle-notch fa-spin m-auto text-2xl" /> : 'Submit'} </button>
            <div className="textContainer">
              {smsSendError ? (
                <div>
                  <span>Error re-sending code. Please </span>
                  <a href={contactUrl} style={{ color: "#28EBC1" }}>
                    contact us
                  </a>
                  .
                </div>
              ) : resent ? (
                <div>
                  <CheckmarkIcon
                    style={{ display: "inline", marginRight: 10 }}
                  />
                  <span>SMS resent</span>
                </div>
              ) : (
                <div className="w-9/12 sm:w-10/12 mx-auto">
                  <span className="cursor-pointer hover:underline" style={{ color: "#0DE0AA" }} onClick={resendSms}>
                    {" "}
                    Re-send SMS
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText">
            <div>
              <span>Use a </span>
              <input
                type="button"
                name="button"
                onClick={useDifferentPhone}
                value="different phone number"
                style={{
                  color: "#0DE0AA"
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.verifyPhone,
    phoneVerificationError: state.register.phoneVerificationError,
    phoneVerified: state.register.phoneVerified,
    smsSendError: state.register.smsSendError
  }),
  actions
)(VerifyCode);
